import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { setAdminAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import PasswordInput from "@/components/PasswordInput";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/admin/login", { email, password });
      setAdminAuth(r.data);
      toast.success("Signed in");
      nav(r.data.user?.role === "super_admin" ? "/super" : "/admin/dashboard");
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen qd-admin grid place-items-center p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl p-8 border border-gray-200 shadow-sm">
        <div className="w-10 h-10 rounded-lg bg-[var(--qd-charcoal)] grid place-items-center mb-6"><Lock className="w-4 h-4 text-white" /></div>
        <h1 className="font-display text-2xl font-bold tracking-tight">Admin sign in</h1>
        <p className="text-sm text-gray-500 mb-6">QRDine restaurant console</p>
        <form onSubmit={submit} className="space-y-3">
          <Input data-testid="admin-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-lg" />
          <PasswordInput data-testid="admin-password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 rounded-lg" />
          <Button data-testid="admin-submit" type="submit" disabled={busy} className="w-full h-11 rounded-lg bg-[var(--qd-charcoal)] hover:bg-black text-white font-semibold">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <Link to="/forgot-password" data-testid="admin-forgot" className="block mt-4 text-sm text-gray-500 hover:text-[var(--qd-primary)] text-center">Forgot password?</Link>
      </div>
    </div>
  );
}
